const actions = {

    STORE_DASHBOARD_DATA_BEGIN : 'STORE_DASHBOARD_DATA_BEGIN',
    STORE_DASHBOARD_DATA_SUCCESS: 'STORE_DASHBOARD_DATA_SUCCESS',
    STORE_DASHBOARD_DATA_ERR : 'STORE_DASHBOARD_DATA_ERR',

    SPL_PRODUCT_TARGET_BEGIN : 'SPL_PRODUCT_TARGET_BEGIN',
    SPL_PRODUCT_TARGET_SUCCESS: 'SPL_PRODUCT_TARGET_SUCCESS',
    SPL_PRODUCT_TARGET_ERR : 'SPL_PRODUCT_TARGET_ERR',

    GET_PRODUCT_DISCOVERY_TOKEN_BEGIN: 'GET_PRODUCT_DISCOVERY_TOKEN_BEGIN',
    GET_PRODUCT_DISCOVERY_TOKEN_SUCCESS: 'GET_PRODUCT_DISCOVERY_TOKEN_SUCCESS',
    GET_PRODUCT_DISCOVERY_TOKEN_ERR: 'GET_PRODUCT_DISCOVERY_TOKEN_ERR',

    STORE_CONTENT_VIDEO_DETAILS_BEGIN: 'STORE_CONTENT_VIDEO_DETAILS_BEGIN',
    STORE_CONTENT_VIDEO_DETAILS_SUCCESS: 'STORE_CONTENT_VIDEO_DETAILS_SUCCESS',
    STORE_CONTENT_VIDEO_DETAILS_ERR: 'STORE_CONTENT_VIDEO_DETAILS_ERR',

    STORE_CONTENT_VIDEO_DOWNLOAD_BEGIN: 'STORE_CONTENT_VIDEO_DOWNLOAD_BEGIN',
    STORE_CONTENT_VIDEO_DOWNLOAD_SUCCESS: 'STORE_CONTENT_VIDEO_DOWNLOAD_SUCCESS',
    STORE_CONTENT_VIDEO_DOWNLOAD_ERR: 'STORE_CONTENT_VIDEO_DOWNLOAD_ERR',

    storeDashboardDataBegin: () => {
        return {
            type: actions.STORE_DASHBOARD_DATA_BEGIN,
        };
    },

    storeDashboardDataSuccess: (data) => {
        return {
            type: actions.STORE_DASHBOARD_DATA_SUCCESS,
            data,
        };
    },

    storeDashboardDataErr: (err) => {
        return {
            type: actions.STORE_DASHBOARD_DATA_ERR,
            err,
        };
    },

    splProductTargetBegin: () => {
        return {
            type: actions.SPL_PRODUCT_TARGET_BEGIN,
        };
    },

    splProductTargetSuccess: (data) => {
        return {
            type: actions.SPL_PRODUCT_TARGET_SUCCESS,
            data,
        };
    },

    splProductTargetErr: (err) => {
        return {
            type: actions.SPL_PRODUCT_TARGET_ERR,
            err,
        };
    },

    getProductDiscoveryTokenBegin: () => {
        return {
            type: actions.GET_PRODUCT_DISCOVERY_TOKEN_BEGIN,
        };
    },

    getProductDiscoveryTokenSuccess: (token) => {
        return {
            type: actions.GET_PRODUCT_DISCOVERY_TOKEN_SUCCESS,
            token,
        };
    },

    getProductDiscoveryTokenErr: (err) => {
        return {
            type: actions.GET_PRODUCT_DISCOVERY_TOKEN_ERR,
            err,
        };
    },

    storeContentVideoDetailsBegin: () => {
        return {
            type: actions.STORE_CONTENT_VIDEO_DETAILS_BEGIN,
        };
    },

    storeContentVideoDetailsSuccess: (data) => {
        return {
            type: actions.STORE_CONTENT_VIDEO_DETAILS_SUCCESS,
            data,
        };
    },

    storeContentVideoDetailsErr: (err) => {
        return {
            type: actions.STORE_CONTENT_VIDEO_DETAILS_ERR,
            err,
        };
    },

    storeContentVideoDownloadBegin: () => {
        return {
            type: actions.STORE_CONTENT_VIDEO_DOWNLOAD_BEGIN,
        };
    },

    storeContentVideoDownloadSuccess: (data) => {
        return {
            type: actions.STORE_CONTENT_VIDEO_DOWNLOAD_SUCCESS,
            data,
        };
    },

    storeContentVideoDownloadErr: (err) => {
        return {
            type: actions.STORE_CONTENT_VIDEO_DOWNLOAD_ERR,
            err,
        };
    },
};

export default actions;
